import { SContainer, SProgress } from './styled';

type LoaderProps = {
  isSemiTransparent?: boolean;
  zIndex?: number;
};

export const Loader = ({ isSemiTransparent = false, zIndex }: LoaderProps) => (
  <SContainer
    sx={(theme) => ({
      opacity: isSemiTransparent ? 0.7 : 1,
      zIndex: zIndex ?? theme.zIndex.loader,
    })}
  >
    <SProgress size={24} />
  </SContainer>
);
